<template>
  <div class="success-wrap">
    <div class="card">
      <div class="head">
        <h1>注册成功</h1>
        <p>请下载APP完善信息</p>
      </div>
      <div class="body">
        <div>
          <img :src="iphone ? imgUrl : imgUrl" alt />
        </div>
        <p>
          名师众享APP
          <br />下载二维码
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { isIPhone } from "../config/common";
import erweima from '../assets/erweima.png';
import andstudent from '../assets/andstudent.png'
import andteacher from '../assets/andteacher.png'
import iosstudent from '../assets/iosstudent.png'
import iosteacher from '../assets/iosteacher.png'

export default {
  name: "Success",
  data() {
      return {
          iphone: isIPhone,
          imgUrl: erweima,
      }
  },
  mounted(){
    const params = this.$route.params;
    if (isIPhone) {
      this.imgUrl = params.type==='1'? iosstudent : iosteacher;
    } else {
      this.imgUrl = params.type==='1'? andstudent : andteacher;
    }
  },
};
</script>

<style scoped lang="scss">
.success-wrap {
  background-color: #a3b1cc;
  min-height: 100%;
  height: auto;
  padding: 52px 26px;
  box-sizing: border-box;

  .card {
    position: relative;
    width: 100%;
    height: 455px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 0 10px #999;

    &::before {
      content: " ";
      position: absolute;
      height: 20px;
      width: 20px;
      background-color: #a3b1cc;
      border-radius: 20px;
      left: -10px;
      top: 106px;
    }

    &::after {
      content: " ";
      position: absolute;
      height: 20px;
      width: 20px;
      background-color: #a3b1cc;
      border-radius: 20px;
      right: -10px;
      top: 106px;
    }

    .head {
      text-align: center;
      padding-top: 41px;
      border-bottom: 1px dashed #e0e0e0;

      h1 {
        font-size: 27px;
        color: #5383e5;
        margin-bottom: 17px;
      }

      p {
        font-size: 13px;
        padding-bottom: 17px;
      }
    }

    .body {
      padding-top: 52px;
      text-align: center;

      img {
        width: 153px;
        height: 153px;
      }

      p {
        padding-top: 12px;
        font-size: 13px;
        font-weight: bold;
        color: #2d2c2c;
        line-height: 1.5;
      }
    }
  }
}
</style>
